import React from 'react'

import { Add, Breakpoints, CTA, styled, useIsMobile } from '@vw-marketing/us-components';

import { Lines } from '../../../../shared/components/icons/Lines';
import { useMyVwContext } from '../../../../shared/hooks/use-my-vw-context';
import { useTrackingManager } from '../../../../shared/hooks/use-tracking-manager';
import { useUser } from '../../../../app/providers/UserContext';
import { onVWBasicButtonClickWithProcessEvent } from '../../../../shared/tagging/tagging-helpers';
import { VWTheme } from '../../../../shared/typings/vw-theme';

const StyledVehicleSectionFooter: any = styled.div`
  ${({ theme }: { theme: VWTheme }) => {
    return `
      display: flex;
      gap ${theme.size.static250};
      justify-content: center;
      padding-top: ${theme.size.static350};

      @media (min-width: ${Breakpoints.b560}px) {
        justify-content: flex-end;
      }

      button:hover svg path {
        fill: currentColor;
      }
    `;
  }}
`;

interface VehicleSectionFooterProps {
  activeCTA: boolean;

  handleClick: () => void;
  handleSwitchVehicles: () => void;
}

export const VehicleSectionFooter = ({ activeCTA, handleClick, handleSwitchVehicles }: VehicleSectionFooterProps) => {
  const isMobile = useIsMobile(Breakpoints.b560);

  const { translationHandler } = useMyVwContext();
  const { user } = useUser();
  const { vehicles = [] } = user || {};
  const trackingManager = useTrackingManager();

  const ctaSize = isMobile ? "small" : "large";
  const isSwitchCtaAvailable: boolean = vehicles.length > 1;

  const handleAddVehicleClick = () => {
    // Track Add Vehicle button click
    try {
      onVWBasicButtonClickWithProcessEvent(trackingManager, {
        Name: 'Vehicle Management',
        StepName: 'Vehicle Details',
        StepNumber: '5',
      }, {
        name: 'Add Vehicle',
      });
    } catch (error) {
      console.warn('Error tracking add vehicle button click:', error);
    }
    
    handleClick();
  };

  const handleSwitchVehiclesClick = () => {
    // Track Switch Vehicles button click
    try {
      onVWBasicButtonClickWithProcessEvent(trackingManager, {
        Name: 'Vehicle Management',
        StepName: 'Vehicle Details',
        StepNumber: '5',
      }, {
        name: 'Switch Vehicles',
      });
    } catch (error) {
      console.warn('Error tracking switch vehicles button click:', error);
    }
    
    handleSwitchVehicles();
  };

  if (!activeCTA && !isSwitchCtaAvailable) return null;

  return (
    <StyledVehicleSectionFooter>
      {activeCTA && (
        <CTA tag="button" emphasis="secondary" icon={<Add variant='small' />} size={ctaSize} onClick={handleAddVehicleClick}>
          {translationHandler('vehicleManagement.addVehicleButton')}
        </CTA>
      )}
      {isSwitchCtaAvailable && (
        <CTA
          tag='button'
          emphasis='primary'
          icon={<Lines />}
          onClick={handleSwitchVehiclesClick}
        >
          {translationHandler('vehicleManagement.switchVehicles.label')}
        </CTA>
      )}
    </StyledVehicleSectionFooter>
  )
}